import { useRef } from 'react'
import { useField, useFormikContext } from 'formik'

import useFocusOnError from '@/hooks/use-focus-on-error'
import { Error, SwitchToggle } from '@/components/form'

const FieldSwitchToggle = ({ name, autoBlur = false, ...rest }) => {
  const formik = useFormikContext()
  const [field] = useField(name)
  const fieldRef = useRef()
  useFocusOnError({ fieldRef, name })
  return (
    <>
      <SwitchToggle
        innerref={fieldRef}
        enabled={field.value}
        onBlur={field.onBlur}
        onChange={v => {
          formik.setFieldTouched(field.name, true)
          formik.setFieldValue(field.name, v, true)
          if (autoBlur)
            setTimeout(() => {
              fieldRef.current.blur()
              fieldRef.current.focus()
            }, 200)
        }}
        name={name}
        aria-checked={field.value}
        {...rest}
      />
      <Error name={name} />
    </>
  )
}

export default FieldSwitchToggle
